export default __webpack_public_path__ + "1.19.2/static/media/LibreDataShare_Japanese.504fe043.svg";